import store from "@/store";

// Arredondamento da Odd;
const RoundHalfDown = function(num) {
  return -(Math.round(-num + "e+2") + "e-2");
};

export default {
  install(Vue) {
    // Tratamento de Aplicação da Margem na ODdd
    Vue.prototype.$treatOdd = function(odd) {
      // Setup
      odd.blocked = false;

      const storeOutcome = this.$store.getters.getResults.find(
        ({ id_outcome }) => id_outcome == odd.id_outcome
      );

      if (storeOutcome.active != "1") {
        odd.blocked = true;
        odd.active = false;
      }
    
      // Status = 2 Bloqueia:
      if (odd.active != "1") {
        odd.blocked = true;
        odd.active = false;
      }

      // IF HORRÍVEL (MELHORAR NO BACK-END!!!)
      // Ocultar Odds - VIEW BIGTABLE
      var urlString = window.location.href;
      var breakpointName = store.state.breakpointName;

      if (urlString.includes("/bt") || urlString.includes("/home")) {
        var outcomesMobile = [
          "6",
          "14",
          "77",
          "78",
          "80",
          "86",
          "101",
          "102",
          "122",
          "124",
        ];
        var outcomesDesktop = ["78", "77", "122", "124", "80", "86"];

        if (breakpointName == "xs" && outcomesMobile.includes(odd.id_outcome)) {
          odd.show = false;
        } else if (
          breakpointName != "xs" &&
          outcomesDesktop.includes(odd.id_outcome)
        ) {
          odd.show = false;
        } else {
          odd.show = true;
        }
      }

      // Recuperando o usuário Logado (que pode ser agente também);
      const odd_price = Number(odd.odd_price);

      //
      // APLICAÇÃO DA MARGIN DA ODD:
      //

      // Calculando a margin
      // Tratando (pre-jogo = odd.margin | live = odd.odd_margin )
      let margin = odd.margin ? Number(odd.margin) : Number(odd.odd_margin);
      // Somando a margin do usuário logado
      // Somar com a margin do usuário
      const logged = store.state.logged.status;
      if (logged) {
        const { margin_odds } = store.state.logged.data;
        margin = Number(margin_odds) + margin;
      }

      // Aplicando a margin na odd
      let odd_price_discount = odd_price - odd_price * margin;

      // Verificando a Odd Máxima;
      let oddTreated =
        odd_price_discount >= odd.odd_limit
          ? odd.odd_limit
          : odd_price_discount;

      // Odd tratada menor que a Odd Mínima Bloqueia:
      if (RoundHalfDown(oddTreated) < Number(store.state.operators.odd_min)) {
        odd.blocked = true;
      }

      // ODD TREATED (Convertendo em String):
      const oddTreatedString = `${RoundHalfDown(oddTreated)}`;
      odd.odd_price = oddTreatedString;

      // Retorna apenas a odd tratada:
      return odd;
    };
  },
};
